import { render, staticRenderFns } from "./ColumnStockDropDownSingleStk.vue?vue&type=template&id=995ec488&scoped=true"
import script from "./ColumnStockDropDownSingleStk.vue?vue&type=script&lang=js"
export * from "./ColumnStockDropDownSingleStk.vue?vue&type=script&lang=js"
import style0 from "./ColumnStockDropDownSingleStk.vue?vue&type=style&index=0&id=995ec488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995ec488",
  null
  
)

export default component.exports